var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"paginations"},[_c('ul',{staticClass:"pagination mt-2"},_vm._l((_vm.links),function(link,key){return _c('li',{key:key,class:_vm.getClass(link)},[_c('a',{staticClass:"page-link",on:{"click":function($event){$event.preventDefault();return _vm.navigation(link)}}},[_vm._v(_vm._s(link.label))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }